import React, {useContext} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import UIPopupContext from "../../popups/UIPopup/UIPopupContext";


const UiPopupAIContentToggleAllGroupsCheckbox = () => {

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {showAllFeatureGroups} = uiPopupContext;

  const toggleShowAllGroups = () => {
    const newShowAllFeatureGroups = !showAllFeatureGroups;

    uiPopupDispatch({
      showAllFeatureGroups: newShowAllFeatureGroups,
    });
  }

  return (
    <div className="flex flex-col flex--top margin-l-8">
      <span className="ui-radio-label nowrap">Show All Groups:</span>
      <button className={"ui-radio ui-radio--small" + (showAllFeatureGroups ? " ui-radio--checked" : "")}
              onClick={toggleShowAllGroups}>
        <span className="ui-radio-circle"/>
        <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
        <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {aiImportData} = store.aiState;
  const {aiSettings} = store.fabricatorState;

  return {
    aiSettings,
    aiImportData,
  };
};

export default connect(mapStateToProps)(UiPopupAIContentToggleAllGroupsCheckbox)

